import Login from 'i18n/pl/Login';
import Offers from 'i18n/pl/Offers';
import DatesUnits from 'i18n/pl/DatesUnits';
import DownloadMobileApp from 'i18n/pl/DownloadMobileApp';
import General from 'i18n/pl/General.json';
import OfferDetail from 'i18n/pl/OfferDetail';
import Jobs from 'i18n/pl/Jobs';
import PendingJobDetail from 'i18n/pl/PendingJobDetail';
import InTransitJobDetail from 'i18n/pl/InTransitJobDetail';
import RecoverPassword from 'i18n/pl/RecoverPassword';
import Chat from 'i18n/pl/Chat';
import Banner from 'i18n/pl/Banner';
import Alerts from 'i18n/pl/Alerts';
import Pods from 'i18n/pl/Pods';
import AccountSettings from 'i18n/pl/AccountSettings';
import Documents from 'i18n/pl/Documents';

const lang = {
  Login,
  Offers,
  DatesUnits,
  DownloadMobileApp,
  General,
  OfferDetail,
  Documents,
  Jobs,
  PendingJobDetail,
  InTransitJobDetail,
  RecoverPassword,
  Chat,
  Banner,
  Alerts,
  Pods,
  AccountSettings
};

export default lang;
